<template>
    <div class="container imputazioni">
        <div class="row justify-content-center bold">
            <div class="col-md-3">
                Progetto
            </div>
            <div class="col-md-3">
                Voce di costo
            </div>
            <div class="col-md-2">
                <span v-tooltip="'Ore lavorate'">H</span>
            </div>
            <div class="col-md-2">
                <span v-tooltip="'Importo economico'">€</span>
            </div>
            <div class="col-md-1">
                <span v-tooltip="'Imputazione percentuale'">%</span>
            </div>
            <div class="col-md-1">&nbsp;</div>
        </div>
        <div class="row justify-content-center" v-for="(imputazione,n) in imputazioni" v-if="ready">
            <div class="col-md-12 " style="margin: 0px; padding: 0px;">
                <span style="font-size: 9px; font-weight: bold;" v-if="imputazione.progetto_id&&progetti.length>0">
                    {{getProgetto(imputazione.progetto_id)}}
                </span>
            </div>
            <div class="col-md-3" style="padding-top: 1px;">
                <v-autocomplete
                    v-if="progetti.length>0"
                    v-model="imputazione.progetto_id"
                    dense
                    attach
                    filled
                    :items="progetti"
                    item-text="text"
                    item-value="value"
                    label="Progetto"
                ></v-autocomplete>
            </div>
            <div class="col-md-3" style="padding-top: 1px;">
                <v-autocomplete
                    v-model="imputazione.vocedicosto"
                    dense
                    attach
                    item-text="text"
                    item-value="value"
                    filled
                    :items="vocidicosto"
                    label="Voce di costo"
                ></v-autocomplete>
            </div>
            <div class="col-md-2" style="padding-top: 1px;">
                <v-text-field
                    v-model="imputazione.workhours"
                    type="number"
                    hide-details
                    label="H/m"
                ></v-text-field>
            </div>
            <div class="col-md-2" style="padding-top: 1px;">
                <v-text-field
                    v-model="imputazione.amount"
                    type="number"
                    hide-details
                    label="€/m"
                ></v-text-field>
            </div>
            <div class="col-md-1" style="padding-top: 1px;">
                <b>{{getPercentuale(imputazione.workhours)}}%</b>
            </div>
            <div class="col-md-1" style="padding-top: 1px;">
                <v-btn @click="removeImputazione(imputazione,n)" color="error">
                    <v-icon small>mdi-delete</v-icon>
                </v-btn>
            </div>

        </div>
        <div class="row justify-content-center bold totali" v-if="ready">
            <div class="col-md-6">
                <v-btn @click="addImputazione" color="primary">
                    <v-icon small>mdi-plus</v-icon>
                    &nbsp;Aggiungi imputazione
                </v-btn>
            </div>
            <div class="col-md-2">
                {{orelavoratetot}}
            </div>
            <div class="col-md-2">
                {{importotot}}
            </div>
            <div class="col-md-1">
                {{percentualetot}}%
            </div>
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-12">
                <div style="margin-top:1em;">
                    <p>
                        Inserisci il numero di ore lavorate per il progetto nel mese o l'importo corrispondente alle ore
                        lavorate,<br/>
                        il sistema calcolerà la percentuale relativa alle ore busta paga imputate.
                        <small>
                            <br/>Inserisci le ore o l'importo lavorato per generare l'imputazione.
                        </small>
                    </p>
                </div>
            </div>

            <div class="col-md-12 text-center">
                <div style="margin-top:1em;" class="text-center">

                    <v-btn @click="salvaImputazioni" color="primary">
                        <v-icon small>mdi-content-save</v-icon>
                        &nbsp;Salva imputazioni
                    </v-btn>
                </div>
                <div style="margin-top:1em;" class="text-center">

                    <v-btn @click="redrawTimesheet" color="success">
                        <v-icon small>mdi-download</v-icon>&nbsp;
                        &nbsp;Rigenera e Scarica Timesheet
                    </v-btn>
                </div>

            </div>
        </div>
    </div>
</template>
<style>
.imputazioni .v-menu__content {
    width: fit-content;
    max-width: fit-content;
}

.imputazioni .v-messages,
.imputazioni .v-text-field__details {
    display: none;
}

.imputazioni .col-md-6,
.imputazioni .col-md-3,
.imputazioni .col-md-4,
.imputazioni .col-md-2,
.imputazioni .col-md-1 {
    margin-bottom: 2px;
    padding-bottom: 3px;
    border-bottom: 1px solid #ccc;
}

.imputazioni .col-md-1,
.imputazioni .totali .col-md-2 {
    display: flex;
    align-items: center;
    align-content: center;
}
</style>
<script>
const _vocidicosto = [
    {'value': 'B1.3', "text": 'B1.3 Elaborazione testi didattici e dispense'},
    {'value': 'B2.1', "text": 'B2.1 Docenza interna'},
    {'value': 'B2.2', "text": 'B2.2 Docenza esterna'},
    {'value': 'B2.3', "text": 'B2.3 Docenza di supporto/codocenza interna'},
    {'value': 'B2.4', "text": 'B2.4 Docenza di supporto/codocenza esterna'},
    {'value': 'B2.5', "text": 'B2.5 Tutoraggio interno'},
    {'value': 'B2.6', "text": 'B2.6 Tutoraggio esterno'},
    {'value': 'B2.8', "text": 'B2.8 Orientamento esterno'},
    {'value': 'B2.9', "text": 'B2.9 Attività di sostegno all\'utenza svantaggiata interna'},
    {'value': 'B2.10', "text": 'B2.10 Attività di sostegno all\'utenza svantaggiata esterna'},
    {'value': 'B4.1', "text": 'B4.1 Direzione progetto'},
    {'value': 'B4.2', "text": 'B4.2 Coordinamento'},
    {'value': 'B4.3', "text": 'B4.3 Attività amministrativa'},
    {'value': 'B4.4', "text": 'B4.4 Costi di monitoraggio interno'},
    {'value': 'B4.5', "text": 'B4.5 Costi di monitoraggio esterno'}
]

export default {
    props: {
        "docenteid": "",
        "monthretributionid": "",
        "timesheeturl":"",
        "progettiurl": "",
        "saveurl": "",
        "anno": null,
        "mese": null,
        "orelavorate": "",
        "imputazionijson": {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            "percentuale": 0,
            "imputazioni": [],
            'progetti': [],
            'ready': false
        }
    },
    computed: {
        vocidicosto() {
            return _vocidicosto
        },
        orelavoratetot() {
            return this.imputazioni.reduce((prev, itm) => {
                return prev + this.numberOrZero(itm.workhours);
            }, 0);

        },
        importotot() {
            return this.imputazioni.reduce((prev, itm) => {
                return prev + this.numberOrZero(itm.amount);
            }, 0);
        },
        percentualetot() {
            const ore = this.orelavoratetot;
            return this.getPercentuale(ore);
        }
    },
    methods: {
        numberOrZero(value) {
            const parsed = parseFloat(value);
            return Number.isFinite(parsed) ? parsed : 0;
        },
        getProgetto(id) {
          const filt = this.progetti.filter((v)=>v.value==id);
          if(filt.length>0) {
              return filt[0].text
          }
          return "-";
        },
        redrawTimesheet() {
            if (typeof this.timesheeturl === 'undefined') {
                toastr.error('Impossibile generare timesheet')
                return
            }
            if ((this.timesheeturl + "").length === 0) {
                toastr.error('Impossibile generare timesheet')
                return
            }
            axios.get(this.timesheeturl).then((result)=>{
                console.log('new time',result);
                if (result) {
                    console.log(result)
                    if(result.data) {
                        toastr.success("Nuovo timesheet generato")
                        window.open(result.data, '_blank').focus();
                    } else {
                        toastr.error('Impossibile generare timesheet')
                    }
                } else {
                    console.error(result)
                    toastr.error('Impossibile generare timesheet')
                }
            }).catch((error)=>{
                console.log(error)
                toastr.error('Impossibile generare timesheet')
            })
        },
        salvaImputazioni() {
            if (typeof this.saveurl === 'undefined') {
                toastr.error('Impossibile salvare imputazioni')
                return
            }
            if ((this.saveurl + "").length === 0) {
                toastr.error('Impossibile salvare imputazioni')
                return
            }
            axios.post(this.saveurl, this.imputazioni).then((result) => {
                if (result) {
                    console.log(result)
                    if(result.data) {
                        toastr.success("Impostazioni salvate con successo")
                    } else {
                        toastr.error('Impossibile salvare imputazioni')
                    }
                } else {
                    console.error(result)
                    toastr.error('Impossibile salvare imputazioni')
                }


            }).catch((error) => {
                console.error(error)
                toastr.error('Impossibile salvare imputazioni')
            })

        },
        removeImputazione(imputazione, indice) {
            this.imputazioni.splice(this.imputazioni.indexOf(imputazione), 1);
            //Api json
        },
        addImputazione() {
            let _imputazione = {
                "progetto_id": "",
                "vocedicosto": "",
                "workhours": null,
                "amount": null,
                "monthretribution_id": this.monthretributionid
            };
            this.imputazioni.push(_imputazione);
        },
        getPercentuale(ore) {
            const oreImputate = this.numberOrZero(ore);
            const oreLavorate = this.numberOrZero(this.orelavorate);
            if (oreImputate < 1 || oreLavorate <= 0) {
                return 0;
            }
            const p = oreImputate / oreLavorate * 100;
            return p.toFixed(2);
        },
        retrieveProgetti() {
            if (typeof this.progettiurl === 'undefined') {
                toastr.error('Impossibile ottenere i progetti')
                return
            }
            if ((this.progettiurl + "").length === 0) {
                toastr.error('Impossibile ottenere i progetti')
                return
            }

            axios.get(this.progettiurl).then((result) => {
                console.log('got result', result);
                if (result && result.data) {
                    this.$set(this, 'progetti', result.data);
                    console.log(this.progetti)
                }
            });
        }
    },
    mounted() {
        console.log('Imputazioni montate', this.vocidicosto)
        this.retrieveProgetti()
        if (typeof this.imputazionijson !== 'undefined') {
            if (Array.isArray(this.imputazionijson)) {
                this.imputazionijson.forEach((imputazione) => {
                    const newImputazione = {
                        "progetto_id": imputazione.progetto_id,
                        "vocedicosto": imputazione.vocedicosto,
                        "workhours": imputazione.workhours,
                        "amount": imputazione.amount,
                        "monthretribution_id": this.monthretributionid
                    }
                    this.imputazioni.push(newImputazione);
                });
            }
        }
        this.ready = true;
    }
}
</script>
